export default {
	userEditSettings: false,
	setupClients: [],
	kamUsers: [],
  attachmentCategories: [],
  manufacturerToken: ''
}
